(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 81);
/******/ })
/************************************************************************/
/******/ ({

/***/ 43:
/***/ (function(module, exports) {

/* eslint-disable no-console */
var customProductPagePopup = {
  init: function init() {
    // comment to remove overlay
    // this.bindOpenModal();
    $(window).on('popstate', function (e) {
      window.location.reload();
    });
    if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
      $('body').addClass('oc-enabled');
    }
  },
  bindOpenModal: function bindOpenModal() {
    $('body').on('click', '.js-customize-open-modal', function (e) {
      e.preventDefault();
      var customUrl = $(this).attr('href');
      customProductPagePopup.openModal(customUrl);
      if (window.applePayDesktopInst) {
        window.applePayDesktopInst.initialize();
        window.applePayDesktopInst.preprocess();
      } else if (window.applePayMobileInst) {
        window.applePayMobileInst.initialize();
        window.applePayMobileInst.preprocess();
      }
    });
  },
  addFluidScript: function addFluidScript() {
    var scr = $('<script id="fluid-configure-script">');
    if ($('#fluid-configure-script').length === 0) {
      scr.attr('src', fluidScriptUrl); // eslint-disable-line
      $('.one-configurator-modal').append(scr);
    }
  },
  openModal: function openModal(customUrl) {
    this.addFluidScript();
    $('.one-configurator-modal').addClass('visible');
    $('body').addClass('oc-overlay-open');
    this.changeUrl(customUrl);
  },
  changeUrl: function changeUrl(customUrl) {
    var customPdpUrl = customUrl;
    window.history.pushState('', '', customPdpUrl);
  }
};
customProductPagePopup.init();

// comment to remove overlay
// const getPdpUrl = window.location.pathname;
window.closePDP = function () {
  window.closePCP();
};
window.closePCP = function (parent) {
  var currentURL = $('#currentUrl').val();
  if (parent === 'logo') {
    window.location.href = currentURL;
  }
  var previousPageUrl = document.referrer;
  var previousPageIsPCP = document.referrer.includes('mostSoldSize') || document.referrer.includes('customize');
  var isRaybanPage = document.referrer.includes('ray-ban');
  if (!previousPageUrl || previousPageIsPCP || !isRaybanPage) {
    // redirect to the home page
    window.location.href = window.wcs_config.topCategoriesDisplayURL;
  } else {
    window.location.href = previousPageUrl;
  }
};
window.recipeLoading = false;
// let sizeChangedObserver = false;

var getJson = function getJson(err, json) {
  window.recipe = json;
};
var disableApplePayBtn = function disableApplePayBtn() {
  if (document.querySelector('.fc-apple-pay')) {
    observeOverlay.disconnect(); // eslint-disable-line
    document.querySelector('.fc-apple-pay').classList.add('applepay-loading');
    $('.apple-pay-button-proceed').after(' <i class="fa fa-pulse fa-spinner fa-2x"></i>');
  }
};
var tryToLoadRecipe = function tryToLoadRecipe() {
  if (!window.recipeLoading) {
    window.recipeLoading = true;
    _getAddToCartRecipe(getJson) // eslint-disable-line
    .then(function () {
      console.log('recipe ready');
      document.querySelector('.fc-apple-pay').classList.remove('applepay-loading');
      $('.fa-spinner').remove();
      observeOverlay.observe(document.querySelector('.fc-dialog-wrapper-container'), {
        // eslint-disable-line
        subtree: true,
        childList: true
      });
    }).catch(function () {
      document.querySelector('.fc-apple-pay').classList.add('applepay-disabled');
    }).finally(function () {
      window.recipeLoading = false;
    });
  }
};
var observeSizeSelect = function observeSizeSelect() {
  new MutationObserver(function (mutations2) {
    console.log('changed size');
    disableApplePayBtn();
    tryToLoadRecipe();
  }).observe(document.querySelector('.fc-sizes-list'), {
    attributes: true,
    subtree: true,
    childList: true
  });
};
var observeOverlay = new MutationObserver(function (mutations) {
  var el = document.getElementById("D_PCP_ExpressCheckout_ApplePay");
  if (el) {
    console.log('element found');
    if (window.applePayDesktopInst) {
      window.applePayDesktopInst.triggerApplePay();
    } else if (window.applePayMobileInst) {
      window.applePayMobileInst.triggerApplePay();
    }
    disableApplePayBtn();
    tryToLoadRecipe();
    // if (!sizeChangedObserver) {
    // sizeChangedObserver = true;
    observeSizeSelect();
    // }
  }
});
document.addEventListener("DOMContentLoaded", function (event) {
  var container = document.getElementsByTagName('body');
  if ($('#productPageName').val() === 'fluidPcp' && window.ApplePaySession) {
    // comment to remove overlay
    // if ($('#productPageName').val() === 'ProductPage' || $('#productPageName').val() === 'fluidPcp') {
    observeOverlay.observe(container[0], {
      subtree: true,
      childList: true
    });
  }
});

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43);
module.exports = __webpack_require__(82);


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/* eslint-disable no-console */

var langId = $('#langId').val();
var storeId = $('#storeId').val();
window.openInstallmentsInfo = function () {
  $(".rb-pay-over-time-pcp-wrapper").removeClass("wcs-hidden");
  window.triggerVueMethod('showPayOverTimeModaOrPanel');
};
$('body').on('click', '#wcs-afterpay-overlay .wcs-close-btn', function (e) {
  e.preventDefault();
  $('body').removeClass('rb-overlay-open');
  $('#wcs-afterpay-overlay').removeClass('active');
});
function addToCartCall(url, params, callback) {
  var ocIdVal = $('#ocIdVal').val();
  var ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'Ocp-Apim-Subscription-Key': '',
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function success(data, status, xhr) {
      console.log('OC call success: ' + xhr.status);
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".sidebar_refreshLS");
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".headerprofile_refreshLS");
      var updateCart = new CustomEvent('addToBag', {
        detail: {
          withRedirectToCart: true
        }
      });
      document.dispatchEvent(updateCart);
      callback(xhr.status);
    },
    error: function error(xhr, status, _error) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + _error);
      callback(xhr.status);
    }
  });
}
function addToWishCall(url, params, callback) {
  var ocIdVal = $('#ocIdVal').val();
  var ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function success(data, status, xhr) {
      callback(xhr.status);
    },
    error: function error(xhr, status, _error2) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + _error2);
      callback(xhr.status);
    }
  });
}
window.fluidAddToCart = function (recipe, callback, orderItemId) {
  var storeID = $('#storeId').val();
  if (recipe.custom.bom.upc === null) {
    recipe.custom.bom.upc = "";
  }
  var params = _objectSpread(_objectSpread({}, recipe.custom.bom), {}, {
    orderItemId: orderItemId
  });
  var hostname = window.location.hostname;
  var url = "https://" + hostname + "/wcs/resources/store/remix/add-to-cart";
  $.ajax({
    url: "https://" + hostname + "/webapp/wcs/stores/servlet/CreateGuestUser?storeId=" + storeID,
    type: "POST",
    dataType: "json",
    success: function success(dati, status, xhr) {
      var userId = dati.userId;
      var et = '&';
      var userGuestId;
      if (userId.indexOf('G') != -1) {
        userGuestId = userId.split('-')[1];
      } else {
        userGuestId = userId;
      }
      var ShopBagUrl = $('input[name=shopBagURL]').val().split('&')[0] + et + "userId=" + userGuestId + et + $('input[name=shopBagURL]').val().split('&')[2] + et + $('input[name=shopBagURL]').val().split('&')[3];
      $('input[name=shopBagURL]').attr('value', ShopBagUrl);
      console.log('OC - CreateGuestUser call success: ' + xhr.status);
      addToCartCall(url, params, callback);
    },
    error: function error(xhr, status, _error3) {
      window.console.log('/add-to-cart Error');
      console.log('OC - CreateGuestUser call failed: ' + xhr.status + ', stauts: ' + status + ', error: ' + _error3);
    }
  });
};
function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}
window.fluidAddToWishes = function (recipe, callback) {
  var params = recipe.custom.bom;
  var hostname = window.location.hostname;
  var url = "https://" + hostname + "/wcs/resources/store/remix/add-to-wishes";
  deleteCookie('miniWhislistSaved');
  sessionStorage.setItem('redDotEnabledFromPCP', 'true');
  addToWishCall(url, params, callback);
};
window.fluidGetMyDesign = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
  var url, params, wishlistItemsRemixReduced;
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        url = window.wcs_endpoints.miniWishlist;
        params = {};
        params.storeId = window.wcs_config.storeId;
        params.catalogId = window.wcs_config.storeId;
        params.langId = window.wcs_config.langId;
        wishlistItemsRemixReduced = '';
        _context.n = 1;
        return $.ajax({
          type: "GET",
          url: url,
          dataType: "json",
          data: params,
          success: function success(data) {
            var wishlistItemsRemix = data.wishLists[0].items.filter(function (item) {
              return item.isRemix;
            });
            wishlistItemsRemixReduced = wishlistItemsRemix.map(function (item) {
              return {
                vendorId: item.partnumber.split('_')[1],
                recipeId: item.configurationId,
                pageURL: item.pdpURL
              };
            });
          },
          error: function error(xhr, status, _error4) {
            console.log('OC getMyDesign failed: ' + xhr + ', status: ' + status + ', error: ' + _error4);
          }
        });
      case 1:
        return _context.a(2, wishlistItemsRemixReduced);
    }
  }, _callee);
}));

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// desktop/assets/scripts/one-configurator.js